/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { I18NTranslationResponse } from '../../models/i-18-n-translation-response';

export interface GetApiPublicI18NTranslation$Params {

/**
 * 2 lower case letter locale
 */
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicI18NTranslation(http: HttpClient, rootUrl: string, params: GetApiPublicI18NTranslation$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NTranslationResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicI18NTranslation.PATH, 'get');
  if (params) {
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<I18NTranslationResponse>;
    })
  );
}

getApiPublicI18NTranslation.PATH = '/api/public/{_locale}/i18nTranslation';
